module.exports = __webpack_public_path__ + "d17eea2108c5256b51f8e912d7e1f894.svg";